module.exports = __webpack_public_path__ + "img/val-icon-1.2b1cdbd0.svg";